"use client";

import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import ui6 from "@/assest/ui6.png";
import RichText from "@/utils/richText";
import { IHeroRecord } from "@/app/package/interface/IHeroSection";

const ContactHero = ({ contactHero }: { contactHero: IHeroRecord[] }) => {
  const [index] = useState(0);
  const sliderImages = contactHero?.[0]?.image || [];
  const currentItem = contactHero?.[0];

  return (
    <div className="relative w-full mb-12">
      <figure className="relative h-100 w-full overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className="absolute inset-0"
          >
            <Image
              src={sliderImages[index]?.image}
              alt="Hero Background"
              fill
              priority
              className="object-cover brightness-[0.65]"
            />
          </motion.div>
        </AnimatePresence>

        <div className="absolute inset-0 bg-linear-to-r from-black/60 to-transparent" />

        <div className="relative z-10 flex flex-col lg:flex-row items-center justify-center h-full px-6 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            className="w-full text-white text-center"
          >
            <h1 className="font-bold text-4xl md:text-6xl lg:text-7xl mb-6">
              {currentItem?.title}
            </h1>

            <RichText
              content={currentItem?.description || ""}
              className="typography-large-body-regular text-gray-200 line-clamp-4 leading-relaxed"
            />
          </motion.div>

          <div className="hidden lg:flex w-full lg:w-1/2 relative h-full items-center justify-end overflow-visible">
            <div className="relative flex items-center gap-6 overflow-visible pr-20">
              {sliderImages.length > 1 && (
                <div className="flex gap-4 items-center">
                  {sliderImages.map((item: any, i: number) => {
                    const isActive = i === index;
                    const isNext = i === (index + 1) % sliderImages.length;

                    if (!isActive && !isNext) return null;

                    return (
                      <motion.div
                        key={item.id}
                        layout
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{
                          opacity: isActive ? 1 : 0.6,
                          scale: isActive ? 1 : 0.9,
                          y: isActive ? -20 : 0,
                        }}
                        className={`relative rounded-2xl overflow-hidden shadow-2xl border-2 border-white/20 ${
                          isActive
                            ? "w-70 h-95 z-20"
                            : "w-55 h-75 z-10"
                        }`}
                      >
                        <Image
                          src={item.image}
                          alt="preview"
                          fill
                          className="object-cover"
                        />
                      </motion.div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </figure>

      <div className="absolute -bottom-6 left-1/3 z-20 hidden md:block">
        <Image
          src={ui6}
          alt="decoration"
          width={80}
          height={80}
          className="animate-bounce-slow"
        />
      </div>
    </div>
  );
};

export default ContactHero;
